export const init = () => {
  const sections = document.querySelectorAll('.js-floating-pagination-section');
  if (!sections.length) return;

  sections.forEach((section) => {
    const paginationElement = section.querySelector('.js-floating-pagination');
    if (!paginationElement) return;

    const pagination = paginationElement.querySelector('.splide__pagination');
    if (!pagination) return;

    if (section.querySelector('.container.bg--white, .container.bg--egyptian_4_100, .container.bg--grey_96')) {
      paginationElement.classList.remove('g-floating-pagination--light');
      paginationElement.classList.add('g-floating-pagination--dark');
    }
    else if (section.querySelector('.container.bg--dark_blue, .container.bg--dark_blue_80_40, .container.bg--primary_dark_blue')){
      paginationElement.classList.remove('g-floating-pagination--dark');
      paginationElement.classList.add('g-floating-pagination--light');
    }
    // Zpoždění scrollovací funkce pro lepší výkon (debouncing)
    let scrollTimeout;
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => initializePaginations(section, paginationElement), 10);
    };

    // Spustí při načtení
    initializePaginations(section, paginationElement);
    window.addEventListener('scroll', handleScroll);

    // Inicializace šířky stránkovacích tlačítek
    const pages = pagination.querySelectorAll('.splide__pagination__page');
    const pageCount = pages.length;
    if(!pageCount) {
      paginationElement.style.display = "none";
    }
    else if (pageCount > 5) {
      const pageWidth = `${(199.86 / pageCount) - 8}px`;
      pages.forEach((page) => page.style.width = pageWidth);
    }
  });
};

function initializePaginations(section, paginationElement) {
  const rect = section.getBoundingClientRect();
  const sectionHalf = rect.height / 4;

  // Přidání třídy .visible, pokud uživatel doscrolluje do poloviny komponenty
  if (rect.top <= window.innerHeight - sectionHalf) {
    paginationElement.classList.add('visible');
  } else {
    paginationElement.classList.remove('visible');
  }
}